import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(theme => ({
  newAnswer: {
    display: 'flex',
    alignItems: 'center',
    marginTop: '0.25rem',

    '& > input': {
      marginRight: '0.125rem',
      border: 'none',
      outline: 'none'
    },

    '& .button': {
      padding: '0 0.5rem'
    }
  },

  answerSection: {
    display: 'flex',
    flexFlow: 'column',
    alignItems: 'baseline'
  },

  newQuestion: {
    display: 'flex',
    alignItems: 'center',
    marginTop: '0.25rem',

    '& > input': {
      marginRight: '0.125rem',
      border: 'none',
      outline: 'none',
      width: '80%'
    }
  },

  marginBottom: {
    marginBottom: '1rem'
  }
}))

export default useStyles
